<script setup>
  import { ref, computed, onBeforeMount } from "vue";
  import { useCompanyStore } from "@/stores/company";
  import { useUiStore } from "@/stores/ui";
  defineProps({
    closeModal: Function,
  });
  const emit = defineEmits(["updateCompany"]);

  const companyStore = useCompanyStore();
  const uiStore = useUiStore();
  const getModalAction = computed(() => uiStore.modalAction);
  const currentCompany = ref(JSON.parse(localStorage.getItem("currentCompany")));
  let id = ref(null);
  let name = ref(null);
  let isSubmitted = ref(false);

  const onSubmit = () => {
    isSubmitted.value = true;
    const data = {
      id: id.value,
      name : name.value,
    };

    companyStore.editCompany(data).then(async (res) => {
        await localStorage.setItem('currentCompany', JSON.stringify(res.data));
        emit('updateCompany');
        uiStore.resetModalStore();
    }).catch(() => {
      isSubmitted.value = false;
    });
  };

  onBeforeMount( () => {
    if(currentCompany.value){
      name.value = currentCompany.value.name;
      id.value = currentCompany.value.id;
    }
  });
</script>

<template>
  <DModal v-if="getModalAction === 'edit_company'" :visible="uiStore.modalState" @update:visible="val => { if (!val) resetStoreData() }" :main_classes="[]" :dialog_classes="[]">
    <template #title> Edit Company </template>
    <template #body>
      <div class="mb-3">
        <DInput :value="name" @input="name = $event.target.value" label="Company Name" width="100%" />
      </div>

      <!-- <p class="delete-text"><b>Note:</b> To change the area’s parent, click the action “Move Area” from the “Sites & Devices” page.    </p> -->

    </template>
    <template #footer>
      <div class="w-full">
        <div class="seperator text-center"></div>
        <div class="flex mt-20 justify-center">
          <button :disabled="!name || isSubmitted"
            @click="onSubmit" type="button" class="btn btn-primary add-button mr-30">
            Edit <span v-if="isSubmitted"  class="spinner-sm" role="status" aria-hidden="true" ></span>
          </button>
          <button @click="uiStore.resetModalStore()" type="button" class="btn btn-secondary cancel-button">Cancel</button>
        </div>
      </div>
    </template>
  </DModal>
</template>
